import { DropdownButtonType, List, ListItem, SingleSelectDropdown, TabStyles } from '@tableau/widgets';
import React from 'react';

import { CommonStyles } from '~common/react/CommonStyles';
import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';

const cssPrefix = 'PublishedConnectionTaskRefreshTypeDropdown';

const menuItemClass = cssClass(cssPrefix, 'menuItem', {
  padding: CommonStyles.Sizes.DefaultSpace,
  $nest: {
    '&:hover': {
      backgroundColor: TabStyles.Colors.Shaded,
    },
  }
});

const menuTextClass = cssClass(cssPrefix, 'menuText', {
  fontWeight: 'bold',
  fontSize: TabStyles.Typography.Sizing.Default,
  color: TabStyles.Typography.Color.PrimaryDark,
  lineHeight: `${CommonStyles.Sizes.LargeSpace}px`,
  display: 'inline-block',
});

const menuDescriptionClass = cssClass(cssPrefix, 'menuDescription', {
  fontSize: TabStyles.Typography.Sizing.Default,
  color: TabStyles.Typography.Color.Secondary,
  lineHeight: `${CommonStyles.Sizes.LargeSpace}px`,
  whiteSpace: 'normal',
});

enum PublishedConnectionTaskRefreshType {
  FullRefresh = 'full'
}

type RefreshMenuItem = Readonly<{
  displayText: string;
  description: string;
  value: string;
}>;

function createListItem(item: RefreshMenuItem): JSX.Element {
  return (
    <div className={menuItemClass}>
      <div className={menuTextClass}>{item.displayText}</div>
      <div className={menuDescriptionClass}>{item.description}</div>
    </div>
  );
}

export const PublishedConnectionTaskRefreshTypeDropdown: React.FC = () => {
  const [selectedRefreshType, setSelectedRefreshType] = React.useState(PublishedConnectionTaskRefreshType.FullRefresh);
  const handleChange = React.useCallback((value) => setSelectedRefreshType(value), []);

  const menuItems = React.useMemo(
    (): ReadonlyArray<RefreshMenuItem> => {
      return [{
        description: Messages.writeOptionsFullHelpText(),
        displayText: Messages.writeOptionsFull(),
        value: PublishedConnectionTaskRefreshType.FullRefresh
      }];
    },
    []
  );

  const listItems = React.useMemo(
    (): ListItem[] => {
      return menuItems.map(item => ({
        content: createListItem(item),
        value: item.value,
      }));
    },
    [menuItems]
  );

  const displayText = React.useMemo(
    () => {
      const selectedItem = menuItems.find(item => item.value === selectedRefreshType);
      return selectedItem?.displayText;
    },
    [menuItems, selectedRefreshType]
  );

  return (
    <SingleSelectDropdown
      type={DropdownButtonType.Outline}
      list={<List items={listItems}/>}
      value={selectedRefreshType}
      testId="published-connection-task-refresh-type-list"
      onChange={handleChange}
      label={''}>{displayText}</SingleSelectDropdown>
  );
};
PublishedConnectionTaskRefreshTypeDropdown.displayName = 'PublishedConnectionTaskRefreshTypeDropdown';
